if (!customElements.get('wls-tabs')) {
  class WLSTabs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        tabButton: 'wls-reviews__tab-button',
        tabPanel: 'wls-reviews__tab-panel',
        activeButton: 'wls-reviews__tab-button--active',
        activePanel: 'wls-reviews__tab-panel--active',
      };

      this.isTransitioning = false;

      // Bind methods
      this.boundSwitchTab = this.switchTab.bind(this);
      this.boundHandleClick = this._handleClick.bind(this);
    }

    get elements() {
      return {
        buttons: this.querySelectorAll(`.${this.classes.tabButton}`),
        panels: this.querySelectorAll(`.${this.classes.tabPanel}`),
      };
    }

    connectedCallback() {
      this._init();
      this.addEventListener('click', this.boundHandleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandleClick);
    }

    _init() {
      this.elements.buttons.forEach(button => {
        button.addEventListener('click', this.boundSwitchTab);
      });
    }

    _handleClick(event) {
      const button = event.target.closest(`.${this.classes.tabButton}`);
      if (!button) return;

      // If button is already active, do nothing
      if (button.classList.contains(this.classes.activeButton)) return;

      this.switchTab(button);
    }

    switchTab(activeButton) {
      if (this.isTransitioning) return;

      const tabIndex = activeButton.dataset.tabIndex;

      // Deactivate old button
      this.elements.buttons.forEach(btn => btn.classList.remove(this.classes.activeButton));
      activeButton.classList.add(this.classes.activeButton);

      // Switch panels
      this.elements.panels.forEach(panel => {
        const isActive = panel.dataset.tabIndex === tabIndex;
        const wasActive = panel.classList.contains(this.classes.activePanel);

        if (wasActive && !isActive) {
          this._hidePanel(panel);
        }

        if (isActive && !wasActive) {
          this._showPanel(panel);
        }
      });
    }

    _hidePanel(panel) {
      this.isTransitioning = true;
      panel.classList.remove(this.classes.activePanel);

      setTimeout(() => {
        this.isTransitioning = false;
      }, 400);
    }

    _showPanel(panel) {
      this.isTransitioning = true;
      panel.classList.add(this.classes.activePanel);

      // Reinitialize slider when tab becomes active and transition completes
      const slider = panel.querySelector('wls-slider');
      if (slider && typeof slider.reInit === 'function') {
        setTimeout(() => {
          slider.reInit();
          this.isTransitioning = false;
        }, 450);
      } else {
        setTimeout(() => {
          this.isTransitioning = false;
        }, 400);
      }
    }
  }

  customElements.define('wls-tabs', WLSTabs);
}